import {updateManyPropertyNotes} from 'ducks/propertyNotes';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import {updatePropertyPreferences} from 'api/propertyPreferences';
import {
  addComparableItem,
  deleteComparableItemImage,
  featureItem,
  fetchComparableItems,
  getPage,
  moveSelectedItem,
  orderSelectedItem,
  removeFeatureItem,
  resetComparableItemFields,
  setDisplayItemField,
  updateComparableItemFetching,
  updateSelectAllItems,
  uploadComparableItemImage
} from 'actionCreators/comparableItems';
import {getComparableSales} from 'api/ComparablesApi';
import { COMPARABLE_TYPE } from '../constants/comparableTypes';

export const UPDATE = 'pulp/comparableSales/UPDATE';
export const ADD_SELECTED = 'pulp/comparableSales/ADD_SELECTED';
export const MOVE_SELECTED = 'pulp/comparableSales/MOVE_SELECTED';
export const ORDER_SELECTED = 'pulp/comparableSales/ORDER_SELECTED';
export const REMOVE_SELECTED = 'pulp/comparableSales/REMOVE_SELECTED';
export const UPDATE_SORT_BY = 'pulp/comparableSales/UPDATE_SORT_BY';
export const LOAD_MORE = 'pulp/comparableSales/LOAD_MORE';
export const UPDATE_SUGGESTED = 'pulp/comparableSales/UPDATE_SUGGESTED';
export const ADD_COMPARABLE = 'pulp/comparableSales/ADD_COMPARABLE';
export const SELECT_ALL = 'pulp/comparableSales/SELECT_ALL';
export const DESELECT_ALL = 'pulp/comparableSales/DESELECT_ALL';
export const UPDATE_ATTRIBUTE = 'pulp/comparableSales/UPDATE_ATTRIBUTE';
export const FEATURE_PROPERTY = 'pulp/comparableSales/FEATURE_PROPERTY';
export const REMOVE_FEATURE_PROPERTY = 'pulp/comparableSales/REMOVE_FEATURE_PROPERTY';
export const SET_DISPLAY_FIELD = 'pulp/comparableSales/SET_DISPLAY_FIELD';
export const RESET_COMPARABLE = 'pulp/comparableSales/RESET_COMPARABLE';
export const UPDATE_ITEM_FETCHING = 'pulp/comparableSales/UPDATE_ITEM_FETCHING';

export function updateForSession(payload, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {propertyDetail: {propertyId: targetPropertyId}} = getState();
      updatePropertyPreferences(targetPropertyId, {
        [`comparableSales.properties.${payload.propertyId}:${JSON.stringify(payload.keyPath)}`]: payload,
      });
    }

    dispatch({type: UPDATE_ATTRIBUTE, payload});
  };
}

export function updateItems(payload) {
  return {type: UPDATE, payload};
}

export function addSelectedItem(propertyId) {
  return (dispatch, getState) => {
    const {
      propertyDetail: {propertyId: targetPropertyId},
      comparableSales: {selected},
      comparableSales: {featured},
    } = getState();

    updatePropertyPreferences(targetPropertyId, {
      'comparableSales.selected': addComparableItem(propertyId, selected, featured)
    });

    dispatch({type: ADD_SELECTED, payload: propertyId});
  };
}

export function removeSelectedItem(propertyId) {
  return (dispatch, getState) => {
    const {
      propertyDetail: {propertyId: targetPropertyId},
      comparableSales: {selected},
      reportType,
    } = getState();
    const newSelected = selected.filter((s) => s !== propertyId);
    updatePropertyPreferences(targetPropertyId, {
      'comparableSales.selected': newSelected,
    });

    //TODO: Check if below code is needed.
    if (!newSelected.length) {
      updatePropertyPreferences(targetPropertyId, {
        'comparableSales.selectedMoved': false,
      });
    }
    AnalyticsGateway.sendEvent({
      eventName: 'Remove Comparable',
      properties: [
        {label: 'Page', value: getPage(reportType, COMPARABLE_TYPE.SALES)}
      ]
    });

    dispatch({type: REMOVE_SELECTED, payload: propertyId});
  };
}

export function updateSortBy(sortBy, savePreference = false) {
  return (dispatch, getState) => {
    if (savePreference) {
      const {propertyDetail: {propertyId}} = getState();
      updatePropertyPreferences(propertyId, {'comparableSales.sortBy': sortBy});
    }

    dispatch({type: UPDATE_SORT_BY, payload: sortBy});
  };
}

export function loadMore() {
  return {type: LOAD_MORE};
}

export function addItem(data, featureFlags = {}) {
  return {type: ADD_COMPARABLE, payload: data, flags: featureFlags};
}

export function updateSuggestedItems() {
  return {type: UPDATE_SUGGESTED};
}

export function fetchItem(propertyId, savePreference = false) {
  return async (dispatch, getState) => {
    const {propertyDetail: {propertyId: targetPropertyId, latitude, longitude}, comparableSales: {selected}} = getState();
    const {propertyNotes, ...data} = await getComparableSales(targetPropertyId, propertyId, latitude, longitude);
    const {featureFlags} = getState();
    dispatch(addItem(data, featureFlags));
    dispatch(updateManyPropertyNotes({[data.propertyId]: propertyNotes}));

    if (savePreference) {
      updatePropertyPreferences(targetPropertyId, {
        'comparableSales.selected': [...selected, propertyId],
      });
    }
  };
}

export const featureProperty = (...args) => featureItem(COMPARABLE_TYPE.SALES)(...args);

export const removeFeatureProperty = (...args) => removeFeatureItem(COMPARABLE_TYPE.SALES)(...args);

export const updateSelectAll = (...args) => updateSelectAllItems(COMPARABLE_TYPE.SALES)(...args);

export const moveSelected = (...args) => moveSelectedItem(COMPARABLE_TYPE.SALES)(...args);

export const orderSelected = (...args) => orderSelectedItem(COMPARABLE_TYPE.SALES)(...args);

export const fetchItems = (...args) => fetchComparableItems(COMPARABLE_TYPE.SALES)(...args);

export const uploadComparableImage = (...args) => uploadComparableItemImage(COMPARABLE_TYPE.SALES)(...args);

export const deleteUploadedImage = (...args) => deleteComparableItemImage(COMPARABLE_TYPE.SALES)(...args);

export const setDisplayField = (...args) => setDisplayItemField(COMPARABLE_TYPE.SALES)(...args);

export const resetComparableProperty = (...args) => resetComparableItemFields(COMPARABLE_TYPE.SALES)(...args);

export const updateFetching = (...args) => updateComparableItemFetching(COMPARABLE_TYPE.SALES)(...args);
